import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import TaskComponent from './component';

import { useAppSelector } from '../../redux/hooks';
import useTaskListInfo from './hooks';

function Task() {
  const navigate = useNavigate();
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  const handleTaskNavigation = (path: string) => {
    navigate(path);
  };

  const { tasks, refetch } = useTaskListInfo({
    patient_id: currentUser?.id,
  });

  useEffect(() => {
    refetch();
  }, [currentUser?.id, refetch]);

  return (
    <TaskComponent
      profileURL={currentUser?.profile_url || ''}
      tasks={tasks}
      handleTaskNavigation={handleTaskNavigation}
    />
  );
}

export default Task;
